<template>
  <div role="main" :id="formId">
    <TheDialog :openDialog="openDialog" :dialogContent="dialogContent" @fechar-dialog="fecharDialog"></TheDialog>
  </div>
</template>

<script setup lang="ts">

const formId = 'melembre-contato-para-sua-empresa-9e5ce9abed3b03caa7b4';
const scriptSrc = 'https://d335luupugsy2.cloudfront.net/js/rdstation-forms/stable/rdstation-forms.min.js';

const openDialog = ref<boolean>(false);
const dialogContent = ref<DialogContent>({
  title: 'Mensagem enviada!',
  text: 'Logo retornaremos o contato',
  image: '/icons/success-modal.svg',
});

const abrirDialog = () => {
  openDialog.value = true;
};

const fecharDialog = () => {
  openDialog.value = false;
};

const sendButton = ref<HTMLElement | null>();

onBeforeMount(() => {
  const formCookies = useCookie('_form_fields')
  formCookies.value = null
});

onMounted(async () => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = scriptSrc;
  script.async = true;
  script.onload = await createForm;
  await document.head.appendChild(script);

  function createForm() {
    new (window as any).RDStationForms(formId, 'UA-139349570-1').createForm();
  }

  window.addEventListener('submit', () => {
    sendButton.value = document.getElementById('rd-button-lmew8kzr');
    setTimeout(() => {
      const inputFields = document.querySelectorAll('input');

      inputFields.forEach(function (input) {
        input.value = '';
        input.classList.remove("error");
      });
      const textareaFields = document.querySelectorAll('textarea');
      textareaFields.forEach(function (input) {
        input.value = '';
        input.classList.remove("error");
      });
    }, 500);

    abrirDialog();
  });

});
</script>

<style lang="scss">
@media screen and (max-width: 510px) {
  div[id^="rdstation-bricks-embeddable-form-bricks-component-"] {
    h2 {
      max-width: 289px !important;
      margin-left: auto !important;
      margin-right: auto !important;
    }

    .bricks--component {
      width: 100% !important;
    }

    .bricks-form__field {
      align-items: center !important;
    }
  }

  #rd-form-lmew8kzo {
    .bricks-form__input {
      max-width: 280px !important;

      &:hover {
        color: #3303ff !important;
      }
    }

    .with-select-flags>.phone-input-group>.phone {
      border-top-left-radius: 10px !important;
      border-bottom-left-radius: 10px !important;
    }
  }
}

div[id^="rdstation-bricks-embeddable-form-bricks-component-"] {
  .js-field-cf_mensagem {
    padding: 8px !important;
  }
}

div[id^="rdstation-bricks-embeddable-form-bricks-component-"] #rd-form-lmew8kzo .with-select-flags > .phone-input-group > .phone {
  border-top-left-radius: 10px !important;
  border-bottom-left-radius: 10px !important;
}
</style>
